var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.06299C3.63739 4.28501 3 5.06806 3 5.99998V18C3 20.2091 4.79086 22 7 22H16C16.9319 22 17.715 21.3626 17.937 20.5H8C6.067 20.5 4.5 18.933 4.5 17V4.06299Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.00154C14.2239 2.00051 14.1978 2 14.1716 2H8C6.89543 2 6 2.89543 6 4V17C6 18.1046 6.89543 19 8 19H19C20.1046 19 21 18.1046 21 17V8.82843C21 8.80223 20.9995 8.77608 20.9985 8.75H16C15.0335 8.75 14.25 7.9665 14.25 7V2.00154ZM9 15.25H15C15.4142 15.25 15.75 15.5858 15.75 16C15.75 16.4142 15.4142 16.75 15 16.75H9C8.58579 16.75 8.25 16.4142 8.25 16C8.25 15.5858 8.58579 15.25 9 15.25ZM8.25 13C8.25 12.5858 8.58579 12.25 9 12.25H13C13.4142 12.25 13.75 12.5858 13.75 13C13.75 13.4142 13.4142 13.75 13 13.75H9C8.58579 13.75 8.25 13.4142 8.25 13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7.25L15.75 2.75V7C15.75 7.13807 15.8619 7.25 16 7.25H20.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.6764b4cde3186ab32b8c0e1f1a09e723.svg";
export { ForwardRef as ReactComponent };